module.exports = __webpack_public_path__ + "static/NotoSans-Italic.subset-5794fcbfb9b2eadd67480e8a9834a90f.woff2";